// tslint:disable
export enum NoteTypeCategory {
    /**
     * @description NOTE
     */
    NOTE = 1,
    /**
     * @description TASK
     */
    TASK = 2,
    /**
     * @description EVENT
     */
    EVENT = 3,
    /**
     * @description Default Note Type
     */
    DefaultNoteType = 4,
}
(NoteTypeCategory as any)['DEFAULTNOTETYPE'] = 4;
